import { Link } from "react-router-dom";

import Button from "../Button";

import { MODULETABS } from "../../../Utils/Constant";
import { useAuth } from "../../../hoc/AuthContext";

// Map module IDs to API field names
const MODULE_NAME_MAPPING = {
  reward: 'reward_name',
  subscription: 'subscription_name',
  travel: 'travel_name',
  commerce: 'commerce_name',
  membership: 'membership_name',
  experience: 'experience_name',
  loyalty: 'loyalty_name',
};

export default function TabModule({ handleModuleClick, activeTab, theme, websiteHeaderInfo }) {
  const { integratorTheme, moduleInfo, isAuthenticated } = useAuth();

  const getFilteredTabs = () => {
    // If moduleInfo is not an array or empty, use default tabs
    if (!Array.isArray(moduleInfo)) {
      return [];
    }

    // If theme is rewards, return all tabs
    // if (theme === "rewards") {
    //   return MODULETABS;
    // }

    // Filter and sort tabs based on moduleInfo
    return MODULETABS
      .filter(tab => moduleInfo.includes(tab.id))
      .sort((a, b) => {
        const aIndex = moduleInfo.indexOf(a.id);
        const bIndex = moduleInfo.indexOf(b.id);
        return aIndex - bIndex;
      });
  };

  // Map tabs to include dynamic titles from websiteHeaderInfo
  const tabsToRender = getFilteredTabs()
    .map((tab) => ({
      ...tab,
      title: websiteHeaderInfo?.[MODULE_NAME_MAPPING[tab.id]]
    }))
    .filter((tab) => tab.title !== null);

  // Optional: Add loading state
  if (isAuthenticated && (!moduleInfo || moduleInfo.length === 0)) {
    return <div className="flex flex-col md:flex-row items-start gap-2.5 md:gap-0">
      <div className="animate-pulse h-10 w-20 bg-gray-200 rounded"></div>
    </div>;
  }

  return (
    <div className="flex flex-col md:flex-row items-start gap-2.5 md:gap-0">
      {tabsToRender.map((tab) => (
        <Link
          to={tab.path}
          key={tab.id}
          onClick={() => handleModuleClick(tab)}
        >
          <Button
            variant="moduleTab"
            isActive={activeTab === tab.id}
            theme={integratorTheme}
            className="p-2.5"
          >
            {tab?.title}
          </Button>
        </Link>
      ))}
    </div>
  );
}